import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function IsNotDealerConfiguratorOrDealerCustomerOrder(props) {
  const {
    isDealerConfigurator,
    order
  } = useContext(ConfiguratorContext)

  const dealerOrderType = order.dealer_order_type ?? ''

  if (isDealerConfigurator && dealerOrderType !== 'customer_car') {
    return null
  }

  return <>{props.children}</>
}
